import { FormHelperText, Grid, InputLabel, FormLabel, CircularProgress } from '@material-ui/core';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import { DatePicker, SecondaryButton, SingelSelect, TextBox } from '../../../../Core/FormInput';
import moment from 'moment';
import { getUserForHoliday, UserHolidays_AddUpdate, getTCardUserHolidayDropdown } from '../../../../Core/Service/TCard-UserHoliday-service.js';
import AppContext from '../../../../App/AppContext.js';
import DialogComp from '../../../../Core/Modal/dialogModal.js';

const AddUpdateHoliday = ({ selectedDate, branchID, userData, onClose }) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        holidayStartDate: userData?.holidayStartDate ? moment(userData?.holidayStartDate).format('YYYY-MM-DD') : selectedDate,
        holidayEndDate: userData?.holidayEndDate ? moment(userData?.holidayEndDate).format('YYYY-MM-DD') : selectedDate,
        tCardUserHolidayRecordID: userData?.tCardUserHolidayRecordID || null,
        holidayNotes: userData?.holidayNotes || '',
        errors: {},
        userID: null,
        userList: [],
        holidayType: null,
        holidayTypeList: []
    });

    console.log('User Data in AddUpdateHoliday:', userData);

    useEffect(() => {
        const fetchUsers = async () => {
            if (branchID && (!state.userList || state.userList.length === 0)) {
                setLoading(true);
                let res = await getUserForHoliday(branchID);
                if (res.success) {
                    let newSt = {};
                    newSt.userList = res.data?.tCards;
                    if (userData?.tCardUserHolidayRecordID) {
                        newSt.userID = res.data?.tCards?.find(({ id }) => id === userData?.userHolidayUserID) || null;
                    }
                    setState((prev) => ({ ...prev, ...newSt }));
                } else {
                    showToast('Failed to fetch users');
                }
                setLoading(false);
            }
        };
        fetchUsers();
    }, [branchID, showToast, selectedDate]);

    useEffect(() => {
        const fetchHolidayTypes = async () => {
            try {
                setLoading(true);
                const res = await getTCardUserHolidayDropdown();
                if (res.success) {
                    setState((prev) => ({
                        ...prev,
                        holidayTypeList: res.data?.holidayType,
                        holidayType: userData?.holidayType ? res.data?.holidayType.find((t) => t.id == userData.holidayType) : null
                    }));
                } else {
                    showToast('Failed to load holiday types.');
                }
            } catch (error) {
                showToast('Error fetching holiday types.');
            } finally {
                setLoading(false);
            }
        };
        fetchHolidayTypes();
    }, []);

    const inputChange = useCallback((e) => {
        const { name, value } = e.target;
        if (name === 'holidayStartDate') {
            setState((st) => ({ ...st, holidayEndDate: moment(value).format('YYYY-MM-DD') }));
        }
        setState((st) => ({ ...st, [name]: value }));
    }, []);

    const OnSingleSelectChange = (nm) => (e, val) => {
        setState((state) => ({
            ...state,
            [nm]: val
        }));
    };

    const validation = () => {
        let isValid = true;
        let errors = {};
        const { userID, holidayEndDate, holidayStartDate, holidayType } = state;

        if (!userID?.id) {
            errors.userID = 'This field is required';
            isValid = false;
        }
        if (!holidayStartDate) {
            errors.holidayStartDate = 'This field is required';
            isValid = false;
        }
        if (!holidayEndDate) {
            errors.holidayEndDate = 'This field is required';
            isValid = false;
        }
        if (!holidayType?.id) {
            errors.holidayType = 'This field is required';
            isValid = false;
        }

        setState((st) => ({ ...st, errors }));
        return isValid;
    };

    const submitFrom = async () => {
        if (validation()) {
            try {
                setLoading(true);
                let data = {
                    tCardUserHolidayRecordID: state.tCardUserHolidayRecordID,
                    HolidayStartDate: state.holidayStartDate,
                    HolidayNotes: state.holidayNotes,
                    BranchID: branchID,
                    HolidayEndDate: state.holidayEndDate,
                    UserHolidayUserID: state.userID?.id,
                    HolidayTypeID: state.holidayType?.id
                };

                let res = await UserHolidays_AddUpdate(data);
                if (res.success) {
                    setLoading(false);
                    showToast('Holiday record saved successfully');
                    onClose(true);
                } else {
                    setLoading(false);
                    showToast(res.message || 'Failed to save holiday record');
                }
            } catch (error) {
                setLoading(false);
                showToast(`An error occurred: ${error.message}`);
            }
        } else {
            showToast('Please fill all required fields');
        }
    };

    if (loading) {
        return (
            <DialogComp maxWidth="md" fullWidth>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '28vh' }}>
                    <CircularProgress />
                </Grid>
            </DialogComp>
        );
    }
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} className="mandatory-fields">
                <InputLabel shrink error>
                    User
                </InputLabel>
                <SingelSelect
                    inputLabel="User"
                    isRequired={true}
                    style={{ marginTop: -8 }}
                    options={state.userList}
                    value={state.userID}
                    onChange={OnSingleSelectChange('userID')}
                />
                <FormHelperText error>{state.errors.userID}</FormHelperText>
            </Grid>

            <Grid item xs={3}>
                <InputLabel shrink error>
                    Start Date
                </InputLabel>
                <DatePicker
                    value={state.holidayStartDate}
                    onChange={inputChange}
                    name="holidayStartDate"
                    error={state.errors.holidayStartDate}
                    InputProps={{ inputProps: { max: state.holidayEndDate, min: selectedDate } }}
                    autoFocus={true}
                />
                <FormHelperText error>{state.errors.holidayStartDate}</FormHelperText>
            </Grid>
            <Grid item xs={3}>
                <InputLabel shrink error>
                    End Date
                </InputLabel>
                <DatePicker
                    value={state.holidayEndDate}
                    onChange={inputChange}
                    name="holidayEndDate"
                    error={state.errors.holidayEndDate}
                    InputProps={{ inputProps: { min: state.holidayStartDate } }}
                />
                <FormHelperText error>{state.errors.holidayEndDate}</FormHelperText>
            </Grid>

            <Grid item xs={6} className="mandatory-fields">
                <InputLabel shrink error style={{ marginBottom: -8 }}>
                    Holiday Type
                </InputLabel>
                <SingelSelect
                    inputLabel="Holiday Type"
                    isRequired={true}
                    style={{ marginTop: -8 }}
                    options={state.holidayTypeList}
                    value={state.holidayType}
                    onChange={OnSingleSelectChange('holidayType')}
                />
                <FormHelperText error>{state.errors.holidayType}</FormHelperText>
            </Grid>

            <Grid item xs={12}>
                <FormLabel component="legend">Notes</FormLabel>
                <TextBox multiline rows={3} autoFocus name="holidayNotes" onChange={inputChange} value={state.holidayNotes} />
            </Grid>
            <Grid item xs={12} style={{ marginBottom: 10 }}>
                <SecondaryButton onClick={submitFrom}>Submit</SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default AddUpdateHoliday;
